import { useSelector, useDispatch } from 'react-redux';
import { useEffect, useState } from 'react';
import { AuthActions } from '../store/reducers/auth';

const useAuth = () => {
  const dispatch = useDispatch();
  const auth = useSelector((state) => state.auth);
  const [isInitializing, setIsInitializing] = useState(true);

  useEffect(() => {
    // This effect runs on mount to ensure the auth state is initialized from storage
    const token =
      localStorage.getItem('token') || sessionStorage.getItem('token');
    const user = localStorage.getItem('user') || sessionStorage.getItem('user');
    const role = localStorage.getItem('role') || sessionStorage.getItem('role');
    const isAuthenticated =
      localStorage.getItem('isAuthenticated') ||
      sessionStorage.getItem('isAuthenticated');

    const selectedCompany =
      localStorage.getItem('selectedCompany') ||
      sessionStorage.getItem('selectedCompany');

    if (token && user) {
      dispatch(
        AuthActions.getAuth({
          user: JSON.parse(user),
          token,
          role: JSON.parse(role),
          isAuthenticated,
          selectedCompany
        })
      );
    }
    
    // Mark initialization as complete
    setIsInitializing(false);
  }, [dispatch]);
  
  return {
    ...auth,
    loading: auth.loading || isInitializing
  };
};
export default useAuth;
